/* Campaign navigation and native collection preview. Commerce stays Shopify-native. */
(function initCampaignStoreContext() {
  if (!document.body.classList.contains('campaign-lab-page')) return;
  const shell = document.querySelector('[data-campaign-store-product-path]');
  const routes = window.CampaignRoutes;
  if (!routes) {
    document.addEventListener('campaign:routes-ready', initCampaignStoreContext, {once: true});
    return;
  }
  if (!shell) return;
  const catalog = document.querySelector('[data-campaign-catalog]');
  const currentUrl = new URL(location.href);
  const catalogPath = shell.dataset.campaignCatalogPath;
  let productPath = shell.dataset.campaignStoreProductPath;
  let catalogReady = !catalog;

  const catalogHref = () => routes.catalogUrl(productPath, location.href, catalogPath);
  const productHref = (view, variant = '') => routes.productUrl(productPath, location.href, view, variant);

  // Previously shared catalog bookmarks now lead to the actual collection route.
  if (catalog?.dataset.catalogKind === 'product' && currentUrl.searchParams.get('view') === 'campaign-lab-home') {
    location.replace(catalogHref());
    return;
  }

  const input = shell.querySelector('[data-campaign-search-input]');
  const form = shell.querySelector('[data-campaign-search-form]');
  const status = shell.querySelector('[data-campaign-search-status]');
  const items = [...shell.querySelectorAll('[data-campaign-search-item]')];
  const normalize = value => value.normalize('NFKC').toLocaleLowerCase().trim();
  const search = () => {
    if (!catalogReady) {
      items.forEach(item => { item.hidden = true; });
      status.textContent = 'The product catalog is still loading. Please try again shortly.';
      return;
    }
    const words = normalize(input.value).split(/\s+/).filter(Boolean);
    let count = 0;
    items.forEach(item => {
      const terms = normalize(item.dataset.searchTerms || item.textContent);
      item.hidden = !words.every(word => terms.includes(word));
      if (!item.hidden) count += 1;
    });
    status.textContent = !words.length ? '' : count ? `${count} ${count === 1 ? 'result' : 'results'}` : 'No matching results. Try the product name or contact support.';
  };
  input.addEventListener('input', search);
  form.addEventListener('submit', event => { event.preventDefault(); search(); });

  function bindContext(card) {
    if (card) {
      productPath = card.dataset.catalogProductPath;
      shell.dataset.campaignStoreProductPath = productPath;
      const title = card.querySelector('h2').textContent.trim();
      const brand = card.dataset.catalogBrand;
      document.title = `Catalog · ${title}`;
      document.querySelector('.brand-lockup__wordmark').textContent = brand;
      document.querySelector('.brand-lockup').setAttribute('aria-label', `${brand} home`);
      document.querySelector('.campaign-lab-footer__brand span').textContent = brand;
      const result = shell.querySelector('.suggestion-product');
      result.href = productHref('campaign-lab');
      result.querySelector('strong').textContent = title;
      result.querySelector('small').textContent = card.querySelector('.campaign-lab-catalog__price strong').textContent;
      result.closest('[data-search-terms]').dataset.searchTerms = card.dataset.catalogSearchTerms;
      const image = card.querySelector('.campaign-lab-catalog__media img');
      if (image && result.querySelector('img')) {
        const thumb = result.querySelector('img');
        thumb.src = image.src;
        thumb.removeAttribute('srcset');
        thumb.removeAttribute('sizes');
      }
      for (const item of [...document.body.classList]) {
        if (item.startsWith('campaign-palette-')) document.body.classList.remove(item);
      }
      document.body.classList.add(`campaign-palette-${['spark', 'holiday', 'halloween'].includes(card.dataset.catalogPalette) ? card.dataset.catalogPalette : 'spark'}`);
    }
    document.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      if (url.origin !== location.origin) return;
      if (link.closest('[data-cart-drawer-content]') && url.pathname !== productPath) return;
      const view = url.searchParams.get('view') || '';
      if (view === 'campaign-lab' && url.pathname.endsWith('/pages/contact')) {
        link.href = productHref('campaign-lab-contact');
      } else if (view === 'campaign-lab' && url.pathname.endsWith('/pages/order-tracking')) {
        link.href = productHref('campaign-lab-tracking');
      } else if (view === 'campaign-lab-home' || (url.pathname === catalogPath && view === 'campaign-lab')) {
        link.href = catalogHref();
      } else if (view.startsWith('campaign-lab') && (url.pathname.includes('/products') || url.pathname === catalogPath)) {
        // Only Campaign presentation links are retargeted; ordinary cart item links remain native.
        link.href = productHref(view, url.searchParams.get('variant') || '');
      }
    });
    form.action = catalogHref();
    const cart = document.querySelector('[data-cart-drawer-content]');
    const retargetCurrentProduct = () => {
      cart?.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.origin);
        if (url.origin !== location.origin) return;
        if (link.closest('.empty-state')) link.href = catalogHref();
        else if (url.pathname === productPath) link.href = productHref('campaign-lab', url.searchParams.get('variant') || '');
      });
    };
    retargetCurrentProduct();
    if (cart && !cart.dataset.campaignObserved) {
      cart.dataset.campaignObserved = 'true';
      new MutationObserver(retargetCurrentProduct).observe(cart, {childList: true, subtree: true});
    }
    search();
  }

  if (!catalog) { bindContext(); return; }

  document.addEventListener('click', event => {
    if (catalogReady) return;
    const link = event.target.closest('a[href]');
    if (link && new URL(link.href).searchParams.get('view')?.startsWith('campaign-lab')) event.preventDefault();
  }, true);

  const content = catalog.querySelector('[data-catalog-content]');
  const feedback = catalog.querySelector('[data-catalog-status]');
  const message = catalog.querySelector('[data-catalog-message]');
  const retry = catalog.querySelector('[data-catalog-retry]');
  const count = catalog.querySelector('[data-catalog-count]');
  function showCatalog(card, source, started) {
    bindContext(card);
    catalogReady = true;
    search();
    content.hidden = false;
    feedback.hidden = true;
    count.textContent = '1 product';
    catalog.dataset.catalogReady = card.dataset.catalogHandle;
    catalog.dataset.catalogSource = source;
    catalog.dataset.catalogWaitMs = String(Math.round(performance.now() - started));
    catalog.setAttribute('aria-busy', 'false');
  }
  async function loadCatalog(fresh = false) {
    const started = performance.now();
    let card = content.querySelector('[data-catalog-handle]');
    if (!fresh && routes.canUseRenderedCatalog(card?.dataset.catalogHandle, card?.dataset.catalogMode, location.href)) {
      showCatalog(card, 'page', started);
      return;
    }
    catalogReady = false;
    content.hidden = true;
    feedback.hidden = false;
    retry.hidden = true;
    count.textContent = '';
    message.textContent = 'Loading product…';
    search();
    catalog.setAttribute('aria-busy', 'true');
    try {
      if (routes.singleSite) throw new Error('Site product unavailable');
      const requested = currentUrl.searchParams.get('item');
      if (requested === null && currentUrl.searchParams.has('preview_key')) throw new Error('Missing draft product');
      if (requested !== null) {
        const result = await routes.requestCatalog(location.href, catalogPath, fresh);
        if (result.error) throw result.error;
        const html = new DOMParser().parseFromString(result.html, 'text/html');
        const sourceContent = html.querySelector('[data-catalog-content]');
        card = sourceContent?.querySelector('[data-catalog-handle]');
        if (!card || card.dataset.catalogHandle !== requested || card.dataset.catalogMode !== '单品独立站') throw new Error('Product mismatch');
        content.replaceChildren(...[...sourceContent.childNodes].map(node => document.importNode(node, true)));
        card = content.querySelector('[data-catalog-handle]');
      }
      if (!card || card.dataset.catalogMode !== '单品独立站') throw new Error('No single-product catalog');
      showCatalog(card, 'request', started);
    } catch {
      // Never fall back to the lamp or a previous item when the requested item fails.
      message.textContent = 'This product could not be loaded. Please try again, or reopen its preview from the product admin.';
      retry.hidden = false;
    } finally {
      catalog.setAttribute('aria-busy', 'false');
    }
  }
  retry.addEventListener('click', () => loadCatalog(true));
  loadCatalog();
})();
